import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const sqRoutes: CustomRouteRecordRaw = {
  path: 'sq',
  name: 'sq',
  component: EmptyLayout,
  meta: {
    title: '职业价值观测试',
    iconfont: 'icon-flask-line',
    requiredPermission: 'sq',
  },
  children: [
    {
      path: 'sq-test-list',
      name: 'sqTestList',
      component: () => import('@/views/sq/sq-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'sq.test.list'
      },
    },
    {
      path: 'sq-test-report',
      name: 'sq-test-report',
      component: () => import('@/views/sq/sq-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'sq.test.report'
      },
    },
  ],
}